import { render, staticRenderFns } from "./autocomplete-chips.vue?vue&type=template&id=511e2687&"
import script from "./autocomplete-chips.vue?vue&type=script&lang=js&"
export * from "./autocomplete-chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "autocomplete-chips.vue"
export default component.exports